module.exports = [{"title":"Work","path":"/work/"},{"title":"About","path":"/about/"},{"title":"Archive","path":"/archive/"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/menu.yaml
// module id = 506
// module chunks = 1474